<template>
    <pm-gallery-layout :current-view="currentView" :gallery-id="galleryId" @changeView="(v) => {currentView = v;}">
        <pm-gallery-list v-if="currentView === 'all'" :grid="grid" />
        <pm-gallery-favourites v-if="currentView === 'favourites'" @openViewer="openViewer" ref="galleryFavourites" />
        <pm-gallery-before-after v-if="currentView === 'before-after'" @openViewer="openViewer" />
        <pm-gallery-page v-if="currentView === 'gallery'" :id="galleryId" :key="galleryId" @openViewer="openViewer" ref="galleryPage" />
        <pm-photo-swipe ref="photoSwipe" @toggleFavved="reload" @changeView="changeView" />
    </pm-gallery-layout>
</template>

<script>
import galleryCategories from "../../configs/gallery/categories.json";
import childCategories from "../../configs/gallery/child-categories.json";
import PmGalleryGroup from "./group";
import MediaList from "../../configs/gallery/media";
import PmGalleryRouteBase from "./gallery_route_base";
import PmGalleryList from "./gallery-list";
import PmGalleryBeforeAfter from "./gallery-before-after";
import PmGalleryFavourites from "./gallery-favourites";
import PmGalleryPage from "./gallery-page";
import PmPhotoSwipe from "./photoswipe";
import MediaSizeConfig from "../../configs/gallery/media-sizes";

export default {
    extends: PmGalleryRouteBase,
    name: "PmModGallery",
    components: {
        PmGalleryGroup,
        PmGalleryList,
        PmGalleryBeforeAfter,
        PmGalleryFavourites,
        PmGalleryPage,
        PmPhotoSwipe,
    },
    data: () => ({
        galleryCategories: galleryCategories,
        hideFooter: ['com.denticalc.photos'].includes(window.packageName),
        galleryId: 0,
    }),
    created() {
        this.t0 = performance.now()
        window.prevGalleryId = 0;
        this.getImageNumbers();
        this.registerBusEvent('openGallery', (id) => {
            this.galleryId = id;

            // Set gallery id.
            localStorage.setItem('currentGalleryId', id);
        });

        /*const idmap = {};
        MediaList.forEach(e=>{
            const gId = String(e.groups[0]);
            const tag = e.tags[0];
            if (!idmap[gId]) idmap[gId] = {};
            if (!idmap[gId][tag]) idmap[gId][tag] = [];
            idmap[gId][tag].push(e.src);
        })
        console.log(JSON.stringify(idmap));*/
    },
    destroyed() {
        // Empty stored gallery id.
        localStorage.setItem('currentGalleryId', String(null));
    },
    activated() {
        if (typeof window.galleryScrollPosition !== "undefined") {
            const el = document.getElementById("gallery-scrollable-container");
            el.style.scrollBehavior = "auto";
            el.scrollTo(0, window.galleryScrollPosition);
            el.style.scrollBehavior = "smooth";
        }
        window.prevGalleryId = 0;
    },
    mounted() {
        if (window["packageName"] === "com.denticalc.photos") {
            window.app.notifyFlutterMounted();
        }
        var t1 = performance.now()

        // this.getImageSizes();

        // @ts-ignore
        window._getImageSizes = this.getImageSizes

        if (!this.$IAP.hasAccessToComponent('photos')) {
            // this.$bus.$emit('openAppDialog','userEmail');
            // this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_photos' });
        } else {
            // if (!this.$IAP.hasPaidAccess('photos') && !this.$IAP.hasTrialAccess()) {
                // this.$bus.$emit('openAppDialog','premium',{'title': '', 'referrer': 'auto_photos_trial'});
            // }
        }
    },
    methods: {

        getImageSizes() {
            let mediaSizes = localStorage.getItem('mediaSizes');
            mediaSizes = mediaSizes ? JSON.parse(mediaSizes) : {};
            // mediaSizes = Object.assign(mediaSizes, MediaSizeConfig);
            const srcMap = new Map();
            for (let i in MediaList) {
                if (!srcMap.has(MediaList[i].src)) srcMap.set(MediaList[i].src,MediaList[i].id);
                if (mediaSizes.hasOwnProperty(MediaList[i].src)) continue;
                this.getImageSize(MediaList[i], mediaSizes);
            }
            console.log('Media Sizes Updated', Object.keys(mediaSizes).length, srcMap.size);
        },
        getImageSize(item, mediaSizes) {
            const baseUrl = "https://cdn.denticalc.com/photos/";
            const img = new Image();
            img.onload = function() {
                item.width = this.width;
                item.height = this.height;
                mediaSizes[item.src] = [item.width, item.height];
                localStorage.setItem('mediaSizes', JSON.stringify(mediaSizes));
            }
            img.src = baseUrl + item.src.replace(".jpg","_full_guetzli.jpg");
        },


        changeView(view) {
            this.currentView = view;
        },
        getImageNumbers() {
            try {
                const imgNum = new Map();
                let unusedItems = new Map();
                let deletedItems = new Map();
                let totalItems = 0;

                MediaList.forEach((item) => {
                    if (item.tags[0].substring(0,2) === "x_" || item.tags[0] === "deleted") {
                        if (item.tags[0] === "deleted") deletedItems.set(item.src);
                        if (deletedItems.has(item.src)) return;
                        unusedItems.set(item.src);
                        return;
                    }
                    totalItems++;
                    let n = imgNum.get(item.groups[0]);
                    if (isNaN(n)) n = 1;
                    else n++;
                    imgNum.set(item.groups[0], n);
                });

                childCategories.forEach(item => {
                    item.imgNum = imgNum.get(item.id);
                });
                // console.log('Used images: ' + totalItems);
                // console.log('Unused images: ' + unusedItems.size);
            } catch(error) {
                captureException(error);
            }
        },
        reload() {
            if (this.$refs['galleryFavourites']) this.$refs['galleryFavourites'].reload();
            if (this.$refs['galleryPage']) this.$refs['galleryPage'].reload();
        },
        openViewer(params) {
            this.$refs['photoSwipe'].init(params);
        },
    },
    beforeRouteLeave(to, from, next) {
        try {
            // Log event with viewed photo count.
            window.Tracker.logEvent({
                event_label: 'photoViews',
                event_name: 'photo_views',
                event_value: parseInt(localStorage.getItem('photoViews') || '0', 10),
            });
        } catch (error) {
            captureException(error);
        } finally {
            // Ensure the call.
            // window.galleryScrollPosition = document.getElementById("gallery-scrollable-container").scrollTop;
            next();
        }
    },
};

</script>

<style>
@media (min-width: 700px) {
    .pm-gallery-breadcrumbs {
        font-size: 18px;
        padding: 10px 15px;
    }

    .pm-gallery-breadcrumbs svg {
        width: 28px;
        height: 28px;
    }

    .v-toolbar__content svg.v-icon {
        display: none; /* other elements? */
    }

    .pm-gallery-grid-4 .pm-gallery-group-items {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>
